// extracted by mini-css-extract-plugin
module.exports = {"pageItem":"styles_pageItem__3hOGh","active":"styles_active__3Zmfg","disabled":"styles_disabled__2XwuT"};